import React, { Component } from "react";
import { withRedux } from "helpers";
import Modal from "@material-ui/core/Modal";
import Punchcard from "./Punchcard";
import PunchCardSettings from "./PunchCardSettings";

class EditPunchCard extends Component {
  componentDidMount() {
    const firstPunchCardId = null || 0;
    this.props.actions.updateActiveEditor(firstPunchCardId);
  }

  componentWillMount() {
    this.props.actions.refreshActiveEditor();
  }

  toggleActiveEditor = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = this.props;
    updateActiveEditor(idx);
  };

  hasPunchCard = () => Object.keys(this.props.cards).length > 0;

  render() {
    const {
      cards,
      activeEditor,
      activeApp: { id },
    } = this.props;
    // console.log(this.props);
    const activePunchCard = cards[activeEditor];
    // console.dir(activePunchCard);
    return (
      <div>
        <PunchCardSettings />
        <Modal
          open={activePunchCard && this.hasPunchCard()}
          disableAutoFocus={true}
          onClose={() => {
            this.toggleActiveEditor(null);
            this.props.actions.removeTempPunchCard();
          }}
          style={{
            top: "1%",
            width: "60%",
            marginLeft: "auto",
            marginRight: "auto",
            overflowY: "auto",
          }}
        >
          <Punchcard
            appId={id}
            {...this.props.actions}
            card={activePunchCard}
            activeApp={this.props.activeApp}
          />
        </Modal>
      </div>
    );
  }
}

export default withRedux(EditPunchCard);
